import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	languages: [],
};

export const cacheSlice = createSlice({
	name: 'cache',
	initialState,
	reducers: {
		setLanguages: (state, action) => {
			state.languages = action.payload;
		},
	},
});

export const { setLanguages } = cacheSlice.actions;

export default cacheSlice.reducer;
